import User from './User';

export default User;



// WEBPACK FOOTER //
// ./src/components/User/index.js